import { currentPopupIDActionsCreator } from "store/toolkit/currentPopupID/currentPopupID.reducer"
export const updateCurrentPopupID = id => currentPopupIDActionsCreator.updateCurrentPopupID(id)

export { updateCurrentPopupID as default }
